import { useCallback, useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SET_NOTIFICATION_DETAIL: 'SET_NOTIFICATION_DETAIL',
  SET_LOADER_NOTIFICATION_DETAIL: 'SET_LOADER_NOTIFICATION_DETAIL',
}

const initialState = {
  notificationDetail: {},
  isLoading: true,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_LOADER_NOTIFICATION_DETAIL:
      return {
        ...state,
        isLoading: action.value,
      }
    case ActionType.SET_NOTIFICATION_DETAIL:
      return {
        ...state,
        notificationDetail: action.value,
        isLoading: false,
      }
    default:
      return state
  }
}

export default function useViewMessage() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const handleAlertError = useCallback(() => {
    return commonDispatch(
      MessageAlert.showError({
        message: formatMessage({
          id: 'error.general',
        }),
      }),
    )
  }, [commonDispatch, formatMessage])

  const fetchNotificationsById = (id) => {
    effects.apis
      .notificationDetail({ notiId: id })
      .then((response) => {
        dispatch({ type: 'SET_NOTIFICATION_DETAIL', value: response })
      })
      .catch(() => handleAlertError())
  }

  const handleFetchNotificationsById = (id) => {
    dispatch({ type: 'SET_LOADER_NOTIFICATION_DETAIL', value: true })
    fetchNotificationsById(id)
  }

  const handleClearNotificationDetail = () => {
    dispatch({ type: 'SET_NOTIFICATION_DETAIL', value: {} })
  }

  return {
    state,
    handleFetchNotificationsById,
    handleClearNotificationDetail,
  }
}
